import "./FoodProcessing.module.css";
import Header from "@/reusable_sections/Header";
import ProcessamentoAlimentosPrincipios from "./sections/ProcessamentoAlimentosPrincipios";
import ProcessamentoDeAlimentosIntro from "./sections/ProcessamentoDeAlimentosIntro";
import Processamentoalimentosshowcase from "./sections/Processamentoalimentosshowcase";
import Footer from "@/reusable_sections/Footer";
export default function FoodProcessingPage() {
  return <div>
      <Header />
      
      <ProcessamentoAlimentosPrincipios />
      <ProcessamentoDeAlimentosIntro />
      <Processamentoalimentosshowcase />
      <Footer />
    </div>;
}